/* eslint-disable no-mixed-operators */
/* eslint-disable array-callback-return */
import { odata } from "@azure/search-documents";
import { IRefinements } from "../../features/Search/types";
import Constants from "./Constants";
import { IUserPermissions, IUserProfile } from "../../features/Auth/types";
import { INavItem } from "../../bosch-react/components/tab-navigation/RbTabNavigation";
import { IMetadataReport } from "../../features/Upload/types";
import { convertToLoginNameList, convertToObjectIdList, removeAliasDomain } from "../../utils/converter";
import _ from "lodash";
import { ILowerFirstCaseMetadata } from "../../features/AccessMediator/types";
import { ILink } from "../../features/Admin/NotificationSetting/NotificationSetting";
import { IAccessTokenCacheEntry } from "../../services/type";
import { decryptString, encryptString } from "../../services/commonServices";
import { ChatModes } from "../../features/OpenAI/types";
class Helper {

  // GENERAL FUNCTIONS
  static getFullDateTimeForDisplay = (dateTimeAsString: Date | string) => new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(dateTimeAsString));

  static getDateTimeFormatForUI(data: any, isShort: boolean = false) {
    if (_.isNil(data)) {
      return "";
    } else if (typeof data === "string") {
      data = new Date(data);
    }
    let monthNames: string[] = [];
    if (isShort === true) {
      monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    } else {
      monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    }
    return (
      (isShort === true
        ? (data.getDate() < 10 ? "0" : "") + data.getDate()
        : data.getDate()) +
      " " +
      monthNames[data.getMonth()] +
      ", " +
      data.getFullYear()
    );
  }

  static isDateWithinNext7Days(dateToCheck: any) {
    if (!!dateToCheck === false) return false
    if (typeof (dateToCheck) === 'string') dateToCheck = new Date(dateToCheck)
    const currentDate = new Date();
    const next7DaysDate = new Date(currentDate);
    next7DaysDate.setDate(currentDate.getDate() + 7);

    // Ensure the time part of the dates is set to 0:00:00 for accurate comparison
    currentDate.setHours(0, 0, 0, 0);
    next7DaysDate.setHours(0, 0, 0, 0);
    dateToCheck.setHours(0, 0, 0, 0);

    return dateToCheck >= currentDate && dateToCheck <= next7DaysDate;
  }

  static getDateTimeFormatForList(data: any) {
    return data.toLocaleString("en-US", { hour12: true });
  }

  static getLastDate(year: number, month: number) {
    let date = new Date(year, month + 1, 0);
    return date.getDate();
  }

  static parseDate(value: any) {
    if (value === "" || _.isNil(value)) {
      return null;
    } else if (value instanceof Date) {
      return value;
    }
    return new Date(value);
  }

  static sortObjects(
    items: any[],
    property: string,
    isAccending: boolean = true
  ) {
    let result = items.sort((a: any, b: any) => {
      let _a = Object.assign({}, a);
      let _b = Object.assign({}, b);
      if (isNaN(_a) && isNaN(_b)) {
        _a[property] = _a[property].toLowerCase();
        _b[property] = _b[property].toLowerCase();
      }
      if (isAccending === true) {
        if (_a[property] > _b[property]) {
          return 1;
        } else {
          return -1;
        }
      } else {
        if (_a[property] < _b[property]) {
          return 1;
        } else {
          return -1;
        }
      }
    });
    return result;
  }

  static encodeCustomized(text: string) {
    let result = text;
    // Replace %
    result = result.replace(/%/g, "___percent___");
    return result;
  }

  static decodeCustomized(text: string) {
    let result = text;
    // Replace %
    result = result.replace(/___percent___/g, "%");
    return result;
  }

  static uniqueStringArray(arr: string[]) {
    let results: string[] = [];
    _.forEach(arr, (item: any) => {
      if (
        results.length === 0 ||
        (results.length > 0 && results.indexOf(item) === -1)
      ) {
        results.push(item);
      }
    });
    results.sort();
    return results;
  }

  static numberWithComma(value: any, isDecimal: boolean = false) {
    if (isDecimal === true) {
      let parts = value.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    } else {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  static generateYearsArray(yearRange: number = 10) {
    let result: any[] = [];
    let currentYear: number = new Date().getFullYear();
    for (
      let year = currentYear - yearRange;
      year <= currentYear + yearRange;
      year++
    ) {
      result.push({ key: year, text: year });
    }
    return result;
  }

  static openDialog(url: string) {
    window.open(
      url,
      "_blank",
      "width=" +
      (window.screen.availWidth / 3) * 2 +
      "px,height=" +
      (window.screen.availHeight / 3) * 2 +
      "px,centerscreen=yes,scrollbars=yes,resizable=yes"
    );
  }

  static openNewTab(url: string) {
    window.open(url, "_blank");
  }

  static openAMPage(reportId: string, isNewTab: boolean = true) {
    const url = this.generateAccessMediatorUrl(reportId)
    if (!!isNewTab)
      this.openNewTab(url)
    else this.reloadPage(url)
  }

  static openSearchPage(keyword: string) {
    const url = `${process.env.REACT_APP_SEARCH_RESUTLS}?keyword=${encodeURIComponent(Helper.encodeCustomized(keyword))}`
    this.openNewTab(url)
  }

  static reloadPage(url: string) {
    window.open(url, "_self");
  }

  static resizeColumnByScreenWidth(input: number) {
    return (
      (input / 100) * // Percentage
      ((document.body.clientWidth * 7) / 12)
    ); // Screen real width - 2 X paddings
  }

  static runNewTask(func: any) {
    setTimeout(() => {
      func();
    }, 10);
  }

  static setEmptyIfNull(value: any) {
    return !_.isNil(value) ? value : "";
  }

  static setZeroIfNull(value: any) {
    return !_.isNil(value) ? value : 0;
  }

  static setEmptyArrayIfNull(value: any) {
    return !_.isNil(value) ? value : [];
  }

  // FOR FEBER BUSINESS

  static getSCShortName(sc: string) {
    let result = "";
    switch (sc) {
      case Constants.SECURITY_CLASS_LONG_NAME.SC1: {
        result = Constants.SECURITY_CLASS_SHORT_NAME.SC1;
        break;
      }
      case Constants.SECURITY_CLASS_LONG_NAME.SC2: {
        result = Constants.SECURITY_CLASS_SHORT_NAME.SC2;
        break;
      }
      case Constants.SECURITY_CLASS_LONG_NAME.SC3: {
        result = Constants.SECURITY_CLASS_SHORT_NAME.SC3;
        break;
      }
    }
    return result;
  }

  static getSCLongName(sc: string) {
    let result = "";
    switch (sc) {
      case Constants.SECURITY_CLASS_SHORT_NAME.SC1: {
        result = Constants.SECURITY_CLASS_LONG_NAME.SC1;
        break;
      }
      case Constants.SECURITY_CLASS_SHORT_NAME.SC2: {
        result = Constants.SECURITY_CLASS_LONG_NAME.SC2;
        break;
      }
      case Constants.SECURITY_CLASS_SHORT_NAME.SC3: {
        result = Constants.SECURITY_CLASS_LONG_NAME.SC3;
        break;
      }
      default:
        return sc
    }
    return result;
  }

  static getSCPostfix(sc: string) {
    let result = "";
    switch (sc) {
      case Constants.SECURITY_CLASS_LONG_NAME.SC1: {
        result = Constants.SECURITY_CLASS_POSTFIX.SC1;
        break;
      }
      case Constants.SECURITY_CLASS_LONG_NAME.SC2: {
        result = Constants.SECURITY_CLASS_POSTFIX.SC2;
        break;
      }
      case Constants.SECURITY_CLASS_LONG_NAME.SC3: {
        result = Constants.SECURITY_CLASS_POSTFIX.SC3;
        break;
      }
    }
    return result;
  }

  static getSCOptionsByDocumentType(documentType: string) {
    let result: any[] = [];
    switch (documentType) {
      case Constants.UPLOAD_TYPE.RnD: {
        result = Constants.DD_SECURITY_CLASSES;
        break;
      }
      case Constants.UPLOAD_TYPE.LL: {
        result = Constants.DD_SECURITY_CLASSES_ONLY_1;
        break;
      }
      case Constants.UPLOAD_TYPE.Thesis: {
        result = Constants.DD_SECURITY_CLASSES_ONLY_2;
        break;
      }
      case Constants.UPLOAD_TYPE.Paper: {
        result = Constants.DD_SECURITY_CLASSES_ONLY_1;
        break;
      }
      default: {
        break;
      }
    }
    return result;
  }

  static getListName(
    documentType: string,
    securityClass: string,
    department: string
  ) {
    let departmentName = department.replace("/", "_");
    if (
      departmentName !== "NoDepartmentReports" &&
      documentType !== Constants.UPLOAD_TYPE.LL &&
      documentType !== Constants.UPLOAD_TYPE.Paper
    ) {
      // RnD or Thesis
      return departmentName + this.getSCPostfix(securityClass);
    }
    // No department or LL or Paper
    return departmentName;
  }

  // static getListNameUrl(type: string) {
  //     return type.replace("SP.Data.", "")
  //         .replace("ListItem", "")
  //         .replace("_x005f_", "_");
  // }

  static getListNameUrl(item: any) {
    let result: string;
    let deptName = item.FeberDepartment.replace("/", "_").replace("_", "_");
    switch (item.SecurityClass) {
      case "1 Internal": {
        result = deptName + "SC1";
        break;
      }
      case "2 Confidential": {
        result = deptName + "SC2";
        break;
      }
      case "3 Strictly Confidential": {
        result = deptName + "SC3";
        break;
      }
      default: {
        result = deptName + "SC1";
      }
    }
    return result;
  }

  static getAccessGroups(
    documentType: string,
    securityClass: string,
    accessGroups: any,
    rouId: any,
    portfolioId: any
  ) {
    let result = [];
    switch (documentType) {
      case Constants.UPLOAD_TYPE.RnD: {
        switch (securityClass) {
          case Constants.SECURITY_CLASS_LONG_NAME.SC2: {
            result.push(accessGroups.RnDDivisionAdmin);
            result.push(accessGroups.SC2Access);
            result.push(rouId);
            if (portfolioId != 0) {
              result.push(portfolioId);
            }
            break;
          }
          case Constants.SECURITY_CLASS_LONG_NAME.SC3: {
            result.push(accessGroups.RnDDivisionAdmin);
            result.push(accessGroups.SC3Access);
            result.push(rouId);
            if (portfolioId != 0) {
              result.push(portfolioId);
            }
            break;
          }
          case Constants.SECURITY_CLASS_LONG_NAME.SC1:
          default: {
            break;
          }
        }
        break;
      }
      case Constants.UPLOAD_TYPE.Thesis: {
        switch (securityClass) {
          case Constants.SECURITY_CLASS_LONG_NAME.SC2: {
            result.push(accessGroups.ThesisAdmin);
            result.push(accessGroups.SC2Access);
            result.push(rouId);
            break;
          }
          case Constants.SECURITY_CLASS_LONG_NAME.SC1:
          default: {
            break;
          }
        }
        break;
      }
    }
    return result;
  }

  static checkBookmarked(guid: string, itemsList: any[]) {
    let result = -1;
    itemsList.forEach((item) => {
      if (item.Guid === guid) {
        result = item.Id;
      }
    });
    return result;
  }

  static getPeoplePickerString(ppsString: string, getNTID: boolean = false) {
    let result: any[] = [];
    if (ppsString !== "") {
      let pps = ppsString.split(";");
      pps.forEach((pp) => {
        let ppArr = pp.split("|");
        result.push(
          getNTID === false
            ? ppArr[1].trim()
            : ppArr[3].indexOf("\\") > -1
              ? ppArr[3].split("\\")[1].trim()
              : ppArr[3].trim()
        );
      });
    } else {
      return "";
    }
    return result.join("; ");
  }

  static getPeopleFullName(ppsString: string) {
    let result: any[] = [];
    if (ppsString !== "") {
      let pps = ppsString.split(";");
      pps.forEach((pp) => {
        let ppArr = pp.split("|");
        result.push(ppArr[1].trim());
      });
    } else {
      return "";
    }
    return result.join("; ");
  }

  static getPeoplePickerStringByObjectArray(data: any[]) {
    let result: string[] = [];
    if (!!data) {
      data.forEach((item: any) => {
        if (item !== null) {
          result.push(item.Title);
        }
      });
    }
    return result.join("; ");
  }

  static mergeAuthors(authors: any[], authorDisplayName: string) {
    let result = "";
    authors.length > 0 && authors.map(author => {
      result += `${!!author.displayName && author.displayName || author}; `;
    })
    result += authorDisplayName;
    return result;
  }

  static checkExistInSystemLists(departmentName: string) {
    let systemLists: any[] = [
      "Composed Looks",
      "Master Page Gallery",
      "Documents",
      "Images",
      "Pages",
      "Site Assets",
      "Site Pages",
      "Workflow Tasks",
      "Microfeed",
      "MicroFeed",
      "Access Requests",
    ];
    let found = false;
    systemLists.forEach((systemList) => {
      if (systemList === departmentName) {
        found = true;
      }
    });
    return found;
  }


  static changeSearchNumberOfResultsFromCache(value: number | null = null) {
    let result: any = 10;
    if (_.isNil(localStorage.getItem("Feber_ResultNumber"))) {
      localStorage.setItem("Feber_ResultNumber", "10");
    }
    if (!_.isNil(value)) {
      localStorage.setItem("Feber_ResultNumber", value.toString());
    }
    result = localStorage.getItem("Feber_ResultNumber");
    return parseInt(result);
  }

  static getUploadTypeDescription(uploadType: string) {
    let result = "";
    switch (uploadType) {
      case Constants.UPLOAD_TYPE.RnD: {
        result = "Research and Development";
        break;
      }
      case Constants.UPLOAD_TYPE.LL: {
        result = "Lessons Learned";
        break;
      }
      case Constants.UPLOAD_TYPE.Thesis: {
        result = Constants.UPLOAD_TYPE.Thesis;
        break;
      }
      case Constants.UPLOAD_TYPE.Paper: {
        result = Constants.UPLOAD_TYPE.Paper;
        break;
      }
    }
    return result;
  }

  static goToPage(history: any, routeName: string) {
    history.push(routeName);
  }

  static setEmptyStringIfUndefined(value: any) {
    return value === undefined ? "" : value;
  }

  static makeFilterString(options: IRefinements, hasRnDRoles: boolean | undefined) {
    let filterString = odata``;
    let { reportType, reportDate, author, division, department } = options
    filterString += `Status eq '${Constants.STATUS.PUBLISHED}'`; // always trim data if it is not published
    filterString += !!reportType ? ` and UploadType eq '${reportType}'` : "";
    filterString += !!department ? ` and search.ismatch('"${department}"','Department','full','any')` : ""
    filterString += !!reportDate ? ` and ${reportDate}` : ""
    filterString += !!division ? ` and search.in(Division, '${division}', ',')` : ""
    filterString += !!author ? ` and Authors/any(author: search.in(author, '${author}', ','))` : ""
    filterString += !!hasRnDRoles ? "" : ` and UploadType ne 'RnD'`;
    return filterString;
  }

  static makeMenuItems(permissions: IUserPermissions) {
    let env = process.env;
    let menuItems: INavItem[] = [
      {
        label: "Search",
        url: env.REACT_APP_SEARCH
      },
      {
        label: "Upload",
        url: env.REACT_APP_UPLOAD
      },
      {
        label: "Account",
        url: env.REACT_APP_ACCOUNT,
        children: [
          {
            label: "Bookmarks",
            url: env.REACT_APP_MY_BOOKMARKS
          },
          {
            label: "Subscriptions",
            hasDivider: true,
            url: env.REACT_APP_MY_SUBSCRIPTION
          },
          {
            label: "My Reports",
            url: env.REACT_APP_MY_REPORTS,
            children: [
              {
                label: "Pending Uploads",
                url: env.REACT_APP_MY_PENDING_REPORTS
              },
              {
                label: "Approved Uploads",
                url: env.REACT_APP_MY_APPROVED_UPLOADS,
              },
              {
                label: "Pending Orders",
                url: env.REACT_APP_MY_PENDING_ORDERS
              },
              {
                label: "Approved Orders",
                url: env.REACT_APP_MY_APPROVED_ORDERS
              },
              {
                label: "Cancelled/Rejected Uploads",
                url: env.REACT_APP_MY_INCOMPLETE_UPLOADS
              }
            ]
          } as INavItem,
          {
            label: "My Workflow",
            url: env.REACT_APP_WORKON_URL,
            onClick: () => { window.open(env.REACT_APP_WORKON_URL) },
            isExternal: true
          }
        ]
      } as INavItem
    ];
    // Load options by permissions
    if (!_.isUndefined(permissions.checkHasPermission)) {
      // Super Admin
      if (permissions.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {
        menuItems.push({
          label: "Admin",
          url: env.REACT_APP_ADMIN,
          children: [
            {
              label: "Admin Upload",
              url: env.REACT_APP_ADMIN_UPLOAD,
            },
            {
              label: "Management",
              url: env.REACT_APP_MANAGEMENT,
            }
          ]
        } as INavItem);
      }
      else {
        // RnD Division Admin
        if (permissions.checkHasPermission([Constants.PERMISSIONS.RND_DIVISION_ADMIN])) {
          menuItems.push({
            label: "Admin",
            children: [
              {
                label: "Admin Upload",
                url: env.REACT_APP_ADMIN_UPLOAD,
              },
              {
                label: "Management",
                url: env.REACT_APP_MANAGEMENT,
              },
            ]
          } as INavItem);
        }
        // LL Admin
        else if (permissions.checkHasPermission([Constants.PERMISSIONS.LL_ADMIN])) {
          menuItems.push({
            label: "Admin",
            children: [
              {
                label: "Admin Upload",
                url: env.REACT_APP_ADMIN_UPLOAD,
              },
              {
                label: "Management",
                url: env.REACT_APP_MANAGEMENT,
              }
            ]
          } as INavItem);
        }
        // LL Division Admin
        else if (permissions.checkHasPermission([Constants.PERMISSIONS.LL_DIVISION_ADMIN])) {
          menuItems.push({
            label: "Admin",
            children: [
              {
                label: "Admin Upload",
                url: env.REACT_APP_ADMIN_UPLOAD,
              },
              {
                label: "Management",
                url: env.REACT_APP_MANAGEMENT,
              }
            ]
          } as INavItem);
        }
        // Thesis Admin
        else if (permissions.checkHasPermission([Constants.PERMISSIONS.THESIS_ADMIN])) {
          menuItems.push({
            label: "Admin",
            children: [
              {
                label: "Admin Upload",
                url: env.REACT_APP_ADMIN_UPLOAD,
              },
              {
                label: "Management",
                url: env.REACT_APP_MANAGEMENT,
              },
            ]
          } as INavItem);
        }
        // Paper Admin
        else if (permissions.checkHasPermission([Constants.PERMISSIONS.PAPER_ADMIN])) {
          menuItems.push({
            label: "Admin",
            children: [
              {
                label: "Admin Upload",
                url: env.REACT_APP_ADMIN_UPLOAD,
              },
              {
                label: "Management",
                url: env.REACT_APP_MANAGEMENT,
              },
            ]
          } as INavItem);
        }

      }
    }
    menuItems.push({
      label: "More",
      url: "abc",
      children: [
        {
          label: "FAQ",
          url: Constants.EXTERNAL_LINKS.FAQ_URL,
          onClick: () => { window.open(Constants.EXTERNAL_LINKS.FAQ_URL) },
          isExternal: true

        },
        {
          label: "User Manual",
          url: Constants.EXTERNAL_LINKS.USER_MANUAL_URL,
          onClick: () => { window.open(Constants.EXTERNAL_LINKS.USER_MANUAL_URL) },
          isExternal: true
        },
        {
          label: "FEBER Community",
          url: env.REACT_APP_FEBER_COMMUNITY_URL,
          onClick: () => { window.open(env.REACT_APP_FEBER_COMMUNITY_URL) },
          isExternal: true

        },
        {
          label: "Service Spec Sheet",
          onClick: () => { Helper.viewSpecSheet() },
          isExternal: true

        }
      ]
    } as INavItem);
    return menuItems
  }

  static prepareUploadPayload(report: any, mode: string = 'user') {
    const temp = Helper.lowerCaseObjectValues({ ...report as IMetadataReport }, ["ROU", "SPFManager", "LLDivisionAdmin"])
    temp.IsAdminMode = (mode === "admin")
    if (!temp.IsAdminMode) {
      temp.SPFManager = report.SPFManager?.managerID ?? "";
      temp.ROU = report.ROU.managerID;
      temp.LLDivisionAdmin = !!report.LLDivisionAdmin?.userPrincipalName && removeAliasDomain(report.LLDivisionAdmin?.userPrincipalName) || "";
    }
    return temp
  }


  static prepareUpdateReport(report: any) {
    let temp = { ...report }
    temp.additionalApprovers = convertToLoginNameList(temp.additionalApprovers)
    temp.authors = convertToLoginNameList(temp.authors)
    temp.authorizedAssociates = convertToLoginNameList(temp.authorizedAssociates)
    temp.notificationUsers = convertToLoginNameList(temp.notificationUsers)
    temp.organizationalUnits = convertToObjectIdList(temp.organizationalUnits)
    temp.customAcl = convertToLoginNameList(temp.customAcl);
    return temp
  }

  static generateAccessMediatorUrl(reportId: string) {
    return `${process.env.REACT_APP_ACCESS_MEDIATOR}/${reportId}`;
  }

  static generateBlobName(reportGuid: string) {
    return `${reportGuid}.pdf`;
  }

  static generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = (Math.random() * 16) | 0;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  static generateNameFileForDownload(title: string, documentNumber: string) {
    // Check special characters
    let fileName = documentNumber + (!!documentNumber ? "_" : "") + title;
    let fileNameArr: string[] = fileName.split("");
    let filteredFileNameArr = fileNameArr.filter(
      (c) => c.match(/^[0-9a-zA-Z]+$/) || c === " " || c === "-" || c === "_"
    );
    // The file name must be less than 255 characters
    let finalArr: string[] = [];
    filteredFileNameArr.forEach((item) => {
      if (finalArr.length <= 255) {
        finalArr.push(item);
      }
    });
    fileName = _.join(finalArr, "");
    return fileName + ".pdf";
  }

  static checkHasPermissionOnDocument = (document: ILowerFirstCaseMetadata | null, profile?: IUserProfile, includeSubmitter: boolean = false) => {
    if (!!document && !!profile) {
      if (profile.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) return true
      if (profile.permissions?.checkHasPermission([Constants.PERMISSIONS.LL_ADMIN]) && document.uploadType?.toLowerCase() === Constants.UPLOAD_TYPE.LL.toLowerCase()) return true
      if (profile.permissions?.checkHasPermission([Constants.PERMISSIONS.THESIS_ADMIN]) && document.uploadType?.toLowerCase() === Constants.UPLOAD_TYPE.Thesis.toLowerCase()) return true
      if (profile.permissions?.checkHasPermission([Constants.PERMISSIONS.PAPER_ADMIN]) && document.uploadType?.toLowerCase() === Constants.UPLOAD_TYPE.Paper.toLowerCase()) return true
      // Check master of data
      if (!!document.rou && removeAliasDomain(profile.loginName?.toLowerCase()) === removeAliasDomain(document.rou.toLowerCase())) return true
      if (!!document.spfManager && removeAliasDomain(profile.loginName?.toLowerCase()) === removeAliasDomain(document.spfManager.toLowerCase())) return true
      // Check Division Admin
      if (document.uploadType?.toLowerCase() === Constants.UPLOAD_TYPE.LL.toLowerCase()) {
        let LLDivAdminChecking = profile.permissions?.checkLLDivisionAdmin
        const isLLDivAdmin = LLDivAdminChecking?.isAdmin && LLDivAdminChecking?.divisionTitle?.toLowerCase() === document.division?.toLowerCase()
        if (isLLDivAdmin) return true
      }
      // Check RnD Division Admin
      if (document.uploadType?.toLowerCase() === Constants.UPLOAD_TYPE.RnD.toLowerCase()) {
        let RnDDivAdminChecking = profile.permissions?.checkRnDDivisionAdmin
        const isRnDDivAdmin = RnDDivAdminChecking?.isAdmin && RnDDivAdminChecking.divisionTitle?.toLowerCase() === document.division?.toLowerCase()
        if (isRnDDivAdmin) return true
      }
      if (includeSubmitter && !!profile.loginName && document.createdBy?.toLowerCase() === removeAliasDomain(profile.loginName.toLowerCase())) return true
    }
    return false
  }

  static checkHasPermissionOnDestination = (uploadType: string, division: string, profile?: IUserProfile) => {
    if (!!profile) {
      if (profile.permissions?.isSuperAdmin) return true
      if (profile.permissions?.isLLAdmin && uploadType.toLowerCase() === Constants.UPLOAD_TYPE.LL.toLowerCase()) return true
      if (profile.permissions?.isThesisAdmin && uploadType.toLowerCase() === Constants.UPLOAD_TYPE.Thesis.toLowerCase()) return true
      if (profile.permissions?.isPaperAdmin && uploadType.toLowerCase() === Constants.UPLOAD_TYPE.Paper.toLowerCase()) return true
      if (uploadType.toLowerCase() === Constants.UPLOAD_TYPE.LL.toLowerCase()) {
        let LLDivAdminChecking = profile.permissions?.checkLLDivisionAdmin
        return LLDivAdminChecking?.isAdmin && LLDivAdminChecking.divisionTitle?.toLowerCase() === division.toLowerCase()
      }
      if (uploadType.toLowerCase() === Constants.UPLOAD_TYPE.RnD.toLowerCase()) {
        let RnDDivAdminChecking = profile.permissions?.checkRnDDivisionAdmin
        return RnDDivAdminChecking?.isAdmin && RnDDivAdminChecking.divisionTitle?.toLowerCase() === division.toLowerCase()
      }
    }
    return false
  }

  static getBookmarkArrayFromSession = (): number[] => {
    const storedArray = sessionStorage.getItem(Constants.SESSION_STORAGE_KEYS.myBookmarks);
    return storedArray ? JSON.parse(storedArray) : [];
  };

  static addBookmarkSessionStorage(reportId: number) {
    let currentValue = this.getBookmarkArrayFromSession()
    let addedValue = [...currentValue, reportId]
    sessionStorage.setItem(Constants.SESSION_STORAGE_KEYS.myBookmarks, JSON.stringify(addedValue))
  }
  static removeBookmarkSessionStorage(reportId: number) {
    let newBookmarkArr = this.getBookmarkArrayFromSession().filter((item) => item !== reportId)
    sessionStorage.setItem(Constants.SESSION_STORAGE_KEYS.myBookmarks, JSON.stringify(newBookmarkArr))
  }

  static setEncryptedSessionStorageWithExpiry = (key: string, value: any, expiryTimeInMinutes: number, subKey: string) => {
    const expiry = new Date().getTime() + expiryTimeInMinutes * 60 * 1000; // Set the expiry time in milliseconds from now
    const data = {
      value: value,
      expiry: expiry
    };
    console.log(subKey, JSON.stringify(data));
    sessionStorage.setItem(key, encryptString(JSON.stringify(data), subKey)); // Store value and expiry as a JSON string
  };

  static getDecryptedSessionStorageWithExpiry = (key: string, subKey: string) => {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const decryptedData = JSON.parse(decryptString(itemStr, subKey));
    const currentTime = new Date().getTime();

    if (currentTime > decryptedData.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }

    return decryptedData.value;
  };

  // Function to set data in sessionStorage with expiry time
  static setSessionStorageWithExpiry = (key: string, value: any, expiryTimeInMinutes: number) => {
    const expiry = new Date().getTime() + expiryTimeInMinutes * 60 * 1000; // Set the expiry time in milliseconds from now
    const data = {
      value: value,
      expiry: expiry
    };
    sessionStorage.setItem(key, JSON.stringify(data)); // Store value and expiry as a JSON string
  };

  // Function to get data from sessionStorage, considering expiry time
  static getSessionStorageWithExpiry = (key: string) => {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const currentTime = new Date().getTime();

    if (currentTime > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }

    return item.value;
  };

  static isValidGuid = (id: string) =>
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id);

  static viewSpecSheet = () => {
    const pdfPath = `${process.env.PUBLIC_URL}/FEBER-service-spec-sheet-en_2024_V4.pdf`;
    window.open(pdfPath, "_blank");
  };

  static openOutlookForSupport = (recipient: string, subject: string, body: string) => {
    const mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${body}`;
    window.location.href = mailtoUrl;
  }

  static splitDisplayNameAndDepartment(displayName: string) {
    const match = displayName.match(/^(.+)\s\((.+)\)$/);
    if (match) {
      const displayName = match[1].trim(); // Extract the display name
      const department = match[2].trim(); // Extract the department
      return { displayName, department };
    }
    return { displayName: "", department: "" };
  }

  static WrapLinksIntoContent(links: ILink[], content: string) {
    let result = content
    links.forEach(link => {
      result = result.replace(link.replacedText, `<a href="${link.hyperLink}" target="_blank">${link.replacedText}</a>`)
    })
    return result
  }

  static generateNumber = () => {
    return Math.floor(Math.random() * 100) + 1
  };

  static sendCIHotlineRequestRnDRole(loginName: string, displayName: string) {
    window.location.href =
      "mailto:ITServiceDesk@bosch.com?" +
      "subject=Request for IDM Role %22" +
      Constants.IDM_GROUPS.RND_USER +
      "%22" +
      "&body=" +
      "Dear CI-Hotline, %0D%0A %0D%0A" +
      "Service Group: oneIDM, %0D%0A %0D%0A" +
      "Please help grant the FEBER idm role %22" +
      Constants.IDM_GROUPS.RND_USER +
      "%22 to my account. %0D%0A" +
      "Reason: Access to FEBER Research and Development reports. %0D%0A %0D%0A" +
      "My NTID is " +
      removeAliasDomain(loginName ?? "") +
      " %0D%0A %0D%0A" +
      "Best Regards, %0D%0A" +
      displayName;
  }

  static getAccessTokenInLocalStorage(scope: string, userId: string) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.includes(scope) && key.includes(userId) && key.includes("accesstoken")) {
        const item = localStorage.getItem(key);
        const cache: IAccessTokenCacheEntry = JSON.parse(item || '{}');
        return cache;
      }
    }
  }

  static lowerCaseObjectValues = <T extends object>(obj: T, fields: (keyof T)[]): T => {
    const newObj = { ...obj };
    fields.forEach(field => {
      const value = newObj[field];
      if (typeof value === 'string') {
        (newObj[field] as any) = value.toLowerCase();
      }
    });
    return newObj;
  };
}
export default Helper;
